import { type DependencyList, type EffectCallback, useEffect, useMemo } from 'react';

const DEFAULT_DEBOUNCE_TIMEOUT = 200;

export function useDebounceEffect(
  effect: EffectCallback,
  deps?: DependencyList,
  timeout = DEFAULT_DEBOUNCE_TIMEOUT
): void {
  // biome-ignore lint/correctness/useExhaustiveDependencies: false
  const persistTimeout = useMemo(() => timeout, []);

  useEffect(() => {
    let tearDown: ReturnType<typeof effect> | undefined;

    const timeoutId = setTimeout(() => {
      tearDown = effect();
    }, persistTimeout);

    return () => {
      clearTimeout(timeoutId);

      tearDown?.();
    };
    // biome-ignore lint/correctness/useExhaustiveDependencies: false
  }, deps);
}
